import { TestID } from 'src/common/TestID';

export enum HEADER_VERSIONS {
    /** Brand blue Zillow full logo with white background on desktop and mobile */
    DEFAULT = 'DEFAULT',
    /** White Zillow full logo with transparent background on mobile */
    TRANSPARENT_MOBILE_ONLY = 'TRANSPARENT_MOBILE_ONLY',
    /** Brand blue Zillow icon only on mobile */
    SEARCH_MOBILE_ONLY = 'SEARCH_MOBILE_ONLY',
    /** Brand blue ZHL full logo with white background on desktop and mobile */
    ZHL_DEFAULT = 'ZHL_DEFAULT',
}

export const ZHL_NAVBAR_BREAKPOINTS_IN_PX = {
    DESKTOP: 1081,
    MOBILE: 1080,
};

export const ZILLOW_NAVBAR_BREAKPOINTS_IN_PX = {
    DESKTOP: 1021,
    MOBILE: 1020,
};

export const ZILLOW_NAVBAR_STATIC_TEST_IDS = {
    HAMBURGER: 'Hamburger',
    MOBILE_DROPDOWN: 'MobileDropdown',
};

export class NavbarSectionTestID extends TestID {
    constructor(name: string) {
        super(`ZillowNavbar|NavbarSection(${name})`);
    }
    get anchor() {
        return new TestID(`${this.id}|${new TestID('Anchor').id}`);
    }
    get megamenu() {
        return new TestID(`${this.id}|${new TestID('MegaMenu').id}`);
    }
}

export class MobileNavbarSectionTestID extends TestID {
    constructor(name: string) {
        super(`ZillowNavbar|MobileNavbarSection(${name})`);
    }
    get anchor() {
        return new TestID(`${this.id}|${new TestID('Anchor').id}`);
    }
    get expandoTrigger() {
        return new TestID(`${this.id}|${new TestID('ExpandoTrigger').id}`);
    }
    get megamenu() {
        return new TestID(`${this.id}|${new TestID('MegaMenu').id}`);
    }
}
